import { render, staticRenderFns } from "./DepositReceiveDetail.vue?vue&type=template&id=1bc36992&scoped=true"
import script from "./DepositReceiveDetail.vue?vue&type=script&lang=js"
export * from "./DepositReceiveDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc36992",
  null
  
)

export default component.exports